import { Component, EventEmitter, Output, Input, ViewChild, ElementRef, Renderer2, AfterViewInit } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { AddToCartConfirmationDTO, ItemMinimalDetails } from 'src/app/shared-core/models/cart-data.model';
import { ProductService } from 'src/app/shared-core/services/product.service';


@Component({
    selector: 'app-add-to-cart-confirmation-dialog',
    templateUrl: './add-to-cart-confirmation-dialog.component.html',
    styleUrls: ['./add-to-cart-confirmation-dialog.component.scss']
})
export class AddToCartConfirmationDialogComponent implements AfterViewInit {
    @Input() public addToCartConfirmationDto: AddToCartConfirmationDTO
    @Output() hidden = new EventEmitter();
    @ViewChild('cartCustomizationModal') cartCustomizationModal: ModalDirective;

    public frequentlyBoughtTogether: ItemMinimalDetails[];

    constructor(
        private _elementRef: ElementRef, 
        private _renderer: Renderer2,
        private _productService: ProductService
    ) { }

    public ngAfterViewInit(): void {
        // Inputs will be strings if called from ASP.NET
        if (typeof this.addToCartConfirmationDto === 'string') {
            this.addToCartConfirmationDto = JSON.parse(this.addToCartConfirmationDto);
        }

        this._productService
            .getFrequentlyBoughtTogetherProducts(this.addToCartConfirmationDto.Webcode, false)
            .subscribe(result => {
                this.frequentlyBoughtTogether = result;
            });

        // Modal appears behind backdrop unless its at top of DOM.
        this._renderer.insertBefore(document.body, this._elementRef.nativeElement, document.body.firstChild, true);

        this.cartCustomizationModal.show();
    }

    public hideDialog(): void {
        this.cartCustomizationModal.hide();
        setTimeout(() => this.hidden.emit(), 300);
    }
}